module.exports = __webpack_public_path__ + "img/pl_payments_guide.be1035b7.jpg";